import * as React from 'react'
import {compose} from 'redux'
import autobind from 'autobind-decorator'
import { RouteComponentProps, withRouter } from 'react-router'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { withToast } from 'src/shared/Toast'
import { WithToast } from 'src/shared/Toast/Toast'
import { IProduct } from 'src/type/product'
import { Enterprise } from 'src/type/enterprise/enterprise'

export const CotationRequestCtx = React.createContext({});

export const withCotationRequest = (Component: any) => (props: any) => (
    <CotationRequestCtx.Consumer>
      {(other: CtxCotationRequest) => <Component {...props} {...other}/>}
    </CotationRequestCtx.Consumer>
);

export interface CtxCotationRequest{
    cotationtDetail: any;
    productSelected: IProduct| undefined;
    enterpriseSelected: Enterprise | undefined;
    formParams: any;
    updateDataProvider: (field: string, data: any) => void;
    updateDataObjProvider: (data: any) => void;
}

interface IProps extends 
    WithToast,
    WithGlobalProgress,
    RouteComponentProps<any>{
}
interface IStates extends CtxCotationRequest{
}

class CotationRequestProvider extends React.Component<IProps, IStates> {
    state = {
        cotationtDetail: undefined,
        formParams: undefined,
        productSelected: undefined,
        enterpriseSelected: undefined,
        updateDataProvider: this.updateInfo,
        updateDataObjProvider: this.updateInfoObj,
    }

    render(){
        return(
            <CotationRequestCtx.Provider value={this.state}>
                {this.props.children}
            </CotationRequestCtx.Provider>
        )
    }

    @autobind
    private updateInfo(field: string, data: any){
        this.setState({...this.state, [field]: data})
    }

    @autobind
    private updateInfoObj(data: any){
        this.setState({...this.state, ...data})
    }

}

export default compose(
  withRouter,
  withGlobalProgress,
  withToast,
)(CotationRequestProvider)


// WEBPACK FOOTER //
// ./src/page/Consumer/Product/cotation/CotationRequestProvider.tsx